import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import {
	SPINNER_SHOW,
	SPINNER_HIDE,
	CREATE_ERROR,
	RESET_ERRORS
} from './constants';

const initialState = fromJS({
	errors: [],
	spinner: {
		pendingProcessCount: 0
	}
});

export const reducer = handleActions(
	{
		[SPINNER_SHOW]: (state) => {
			const processCount = state.getIn(['spinner', 'pendingProcessCount']);
			return state.setIn(['spinner', 'pendingProcessCount'], processCount + 1);
		},

		[SPINNER_HIDE]: (state) => {
			const processCount = state.getIn(['spinner', 'pendingProcessCount']);
			if (processCount > 0) {
				return state.setIn(['spinner', 'pendingProcessCount'], processCount - 1);
			} else {
				console.warn('Ignored action: SPINNER_HIDE'); // TODO: is this needed? Causes warning
				return state;
			}
		},

		[RESET_ERRORS]: (state) => state.set('errors', fromJS([])),

		[CREATE_ERROR]: (state, action) => {
			const errors = state.get('errors');
			return state.set('errors', fromJS([...errors, action.payload]));
		}
	},
	initialState
);

export default reducer;
